import { useInputTextContext } from '../../input-text'
import type {
  InputTextLabelProps,
  InputTextScopedProps,
} from '../../input-text.types'
import { inputTextLabelVariants } from './index.styles'

export const InputTextLabel = (
  props: InputTextScopedProps<InputTextLabelProps>
) => {
  const { __scopeInputText, children, ...rest } = props

  const { disabled, readOnly, size } = useInputTextContext(
    'InputTextLabel',
    __scopeInputText
  )

  if (!children) return null

  return (
    <div className="flex h-extrasmall w-[100%] items-center rounded-none border-none px-onepulse text-left">
      <label
        {...rest}
        className={inputTextLabelVariants({ disabled, readOnly, size })}
        aria-disabled={disabled}
      >
        {children}
      </label>
    </div>
  )
}
